import { HelpText, Icon, Label, Tooltip } from '@lego/connect-components-react';
import type { ReactNode } from 'react';

type HelpTextProps = {
  text: string;
  variant?: 'negative' | 'neutral' | 'warning';
};

type LabeledFieldProps = {
  label: string;
  tooltipText?: ReactNode;
  helpText?: HelpTextProps;
  disabled?: boolean;
  children: ReactNode;
};

export const LabeledField = ({
  label,
  tooltipText,
  helpText,
  disabled,
  children,
}: LabeledFieldProps) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      opacity: disabled ? 0.4 : undefined,
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <Label>{label}</Label>
      {tooltipText && (
        <Tooltip>
          <Tooltip.Trigger>
            <Icon aria-label="Information" name="circle-info" size="small" />
          </Tooltip.Trigger>
          <Tooltip.Content>{tooltipText}</Tooltip.Content>
        </Tooltip>
      )}
    </div>
    {children}
    {helpText && (
      <HelpText variant={helpText.variant ?? 'negative'}>
        {helpText.text}
      </HelpText>
    )}
  </div>
);
